// extracted by mini-css-extract-plugin
module.exports = {"btn-close":"video-modal_btn-close__331go","btnClose":"video-modal_btn-close__331go","video":"video-modal_video__3JKHQ","root":"video-modal_root__GAOCM"};